import styled from 'styled-components';

import {getLocalizationService} from '~/shared/services/localisationService';
import {media} from '~/shared/theme/utils';
import {body14Normal, body14Bold} from '~/shared/theme/typography';
import ImageWithAlt from '~/shared/components/ImageWithAlt';

import tableTooBigImageUrl from './assets/images/table_too_big.png';

// #region styled components

const ScreenSizeErrorImage = styled(ImageWithAlt).attrs({
  src: tableTooBigImageUrl,
})`
  height: 185px;
  width: 185px;
  ${media.minDesktop`
    height: 277px;
    width: 277px;
  `};
`;

const Root = styled.div`
  margin-top: 48px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const Title = styled.div`
  ${body14Bold}
  color: ${({theme}) => theme.colors.secondary};
  text-align: justify;
  line-height: 20px;
`;

const Description = styled.div`
  ${body14Normal}
  color: ${({theme}) => theme.colors.secondary};
  text-align: justify;
  line-height: 20px;
`;

// #endregion

const ScreenSizeError = () => {
  const {t} = getLocalizationService();

  return (
    <Root>
      <Title>{t('table_error_title')}</Title>
      <Description>{t('table_error_description')}</Description>
      <ScreenSizeErrorImage noAlt />
    </Root>
  );
};

export default ScreenSizeError;
